module.exports = __webpack_public_path__ + "static/img/member21.364ca9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member21.jpg
// module id = yQrj
// module chunks = 0